import * as React from 'react';
import { EditState, EditProps, BaseRouteProps } from '../../interfaces';
import { Question, Survey, SurveyVersion } from '../../models';
import { QuestionDataService, SurveyDataService, SurveyVersionDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { QuestionForm } from './QuestionForm';
import { LoadingIndicator, PVAPage } from '../../components';

interface QuestionEditState extends EditState<Question> {
    hasPublished: boolean;
}

export class QuestionEdit extends React.Component<BaseRouteProps<EditProps>, QuestionEditState> {
    private questionDataService = new QuestionDataService(this.props.notificationService);
    private surveyService = new SurveyDataService(this.props.notificationService);
    private surveyVersionService = new SurveyVersionDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<EditProps>) {
        super(props);

        this.state = {
            originalEntity: undefined,
            hasPublished: false
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        const id = this.props.match.params.id;

        if (id) {
            this.questionDataService.get(id).then((question: Question) => {
                question.questionTexts = question.questionTexts || [];
                question.characteristicScores = question.characteristicScores || [];
                this.setState({ originalEntity: question });

                this.surveyService.get(question.surveyID).then((survey: Survey) => {
                    this.surveyVersionService.getAllBySurvey(survey).then((surveyVersions: SurveyVersion[]) => {
                        this.setState({ hasPublished: surveyVersions.some(x => x.published !== null) });
                    });
                });
            });
        }
    }

    public render() {
        if (!this.state.originalEntity) {
            return <LoadingIndicator />;
        }

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={`/survey/${this.state.originalEntity.surveyID}`}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp; Edit Statement
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <QuestionForm defaultValues={this.state.originalEntity} submit={this.save} notificationService={this.props.notificationService} hasPublishedVersion={this.state.hasPublished}/>
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.questionDataService.update(values).then((success) => {
            this.props.history.push(`/survey/${this.state.originalEntity!.surveyID}`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/question/QuestionEdit.tsx